// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e92db7e2","667":"3cf66351","977":"638eb26d"}[chunkId] + ".chunk.js";
};